<template>
    <div class="l-row o-dashboard">
        <div class="l-row__column o-dashboard__column o-dashboard__column--left">
            <a-button
                type="light"
                icon="FavoriteDashboard"
                @click="$router.push({ name:'favorites' })"
                :process-on-click="true"
            >
                Ulubione
            </a-button>
            <a-button
                type="light"
                icon="Agrofags"
                @click="$router.push({ name:'agrofags' })"
                :process-on-click="true"
            >Agrofagi</a-button>
            <!-- <a-button
                type="light"
                icon="Agrofags"
                @click="$router.push({ name:'deficienciesList' })"
                :process-on-click="true"
            >
                Niedobory
             </a-button> -->
            <a-button
                type="light"
                icon="Protectors"
                @click="$router.push({ name:'protectors' })"
                :process-on-click="true"
            >
                Środki
            </a-button>
            <a-button
                type="light"
                icon="Crops"
                @click="$router.push({ name:'crops' })"
                :process-on-click="true"
            >
                Uprawy
            </a-button>
            <a-button
                type="light"
                icon="ActiveSubstances"
                @click="$router.push({ name:'active-substances' })"
                :process-on-click="true"
            >
                Substancje aktywne
            </a-button>
        </div>
        <div class="l-row__column o-dashboard__column o-dashboard__column--right">
            <div class="o-dashboard__sidebar">
                <a-button
                    type="square"
                    icon="AdvancedSearch"
                    @click="$router.push({ name:'search' })"
                >
                    Wyszukiwanie zaawansowane
                </a-button>
                <!-- Alerty ukryte: Origin zakończył synchronizację alertów
                <a-button
                    type="square"
                    icon="Alerts"
                    @click="$router.push({ name:'alerts' })"
                >
                    Alerty
                </a-button>
                -->
                <a-button
                    v-if="authIsAdvisor"
                    type="square"
                    icon="Customers"
                    @click="$router.push({ name:'users' })"
                >
                    Klienci
                </a-button>
                <!-- <a-button
                    type="square"
                    icon="Knowledge"
                    @click="$router.push({ name:'knowledgeGroupList' })"
                >
                    Wiedza
                </a-button> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
    metaInfo: {
        title: 'Pulpit'
    },
    computed: {
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    created() {
        this.$store.dispatch('fetchBanner')
    }
}
</script>
